import { createFileRoute, redirect } from "@tanstack/react-router";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/gebrauchte-mercedes-benz/")({
  head: () => routeHead("/de/gebrauchte-mercedes-benz/"),
  beforeLoad: () => {
    throw redirect({ href: "/de/cars/mercedes-benz", statusCode: 301, replace: true });
  },
});
